export const Environment = {
  production: 'app.gmpplus.org',
  development: 'app-dev.gmpplus.org',
  test: 'app-test.gmpplus.org',
  acceptance: 'app-acc.gmpplus.org',
  local: 'localhost',
} as const

export type EnvironmentHostname = (typeof Environment)[keyof typeof Environment]

export enum EnvironmentTypes {
  portal = 'portal',
  management = 'management',
  academy = 'academy',
  cms = 'cms',
}
